import { SET_ERRO } from "../actions";

export default function erroReducer(state = null, action){

    switch(action.type){
        case SET_ERRO:
            return action.value;
        default:
            return state;
    }
}